import { Head } from '@inertiajs/react'
import { Box } from '@mui/material'
import { HomeTab, ProspectMainLayout } from '../../components'

interface HomePageProps {
    pending_tour_requests_count?: number;
    upcoming_tours_count?: number;
    prospect_short_code?: string;
    prospect_id?: string;
}

export default function HomePage({
    pending_tour_requests_count = 0,
    upcoming_tours_count = 0,
    prospect_short_code,
    prospect_id
}: HomePageProps) {
    return (
        <>
            <Head title="Home - HeyyProperty" />

            <ProspectMainLayout
                activeTab="home"
            >
                <Box sx={{ py: 1 }}>
                    <HomeTab
                        pending_tour_requests_count={pending_tour_requests_count}
                        upcoming_tours_count={upcoming_tours_count}
                        prospect_short_code={prospect_short_code}
                        prospect_id={prospect_id}
                    />
                </Box>
            </ProspectMainLayout>
        </>
    )
}
